import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rotationsBuildSchedules: {
		id: 'eoc-on-call.tours.list-rotation.rotations-build-schedules',
		defaultMessage: 'Rotations build on-call schedules',
		description: 'Title of list rotation spotlight.',
	},
	chooseToRotateShiftsMeetTeamsNeed: {
		id: 'eoc-on-call.tours.list-rotation.choose-to-rotate-shifts-meet-teams-need',
		defaultMessage:
			"Choose to rotate shifts daily, weekly, or customize to meet your team's needs and ensure maximum coverage for alert response.",
		description: 'Description of list rotation spotlight.',
	},
});
